import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

// Custom hook to guard against navigation when there are unsaved changes (isDirty = true).
const useNavigationGuard = (isDirty: boolean) => {
    const blocker = useBlocker(isDirty);

    useEffect(() => {
        if (!isDirty) return;

        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            e.preventDefault();
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isDirty]);

    const isBlocked = blocker.state === 'blocked';

    const proceed = () => {
        if (blocker.state === 'blocked') {
            blocker.proceed();
        }
    };

    const cancel = () => {
        if (blocker.state === 'blocked') {
            blocker.reset();
        }
    };

    return { isBlocked, proceed, cancel };
};

export default useNavigationGuard;
